<ion-toolbar class="main-header-toolbar">
    <app-header *ngIf="this.isItParent"></app-header>
    <app-student-header *ngIf="this.isItStudent"></app-student-header>
</ion-toolbar>


<ion-content [fullscreen]="true" class="content">

    <ion-grid fixed class="page-grid"
              [ngClass]="{'no-margin-top': this.isItStudent, 'student-grid student-page': this.isItStudent}">

        <ion-row class="wrapper-page study-content ion-align-items-center">

            <ion-col size="12">

                <div class="wrapper-404">
                    <div class="title">

                        {{ '404page'| transloco }}

                    </div>

                    <div class="btn  dark-btn" [routerLink]="'/home'">  {{ '404page.btn'| transloco }}</div>
                </div>


            </ion-col>


        </ion-row>


    </ion-grid>

    <app-footer></app-footer>

</ion-content>
